module.exports = __webpack_public_path__ + "static/adwokatGdyniaPoradyPrawne-26dc0e4e96a8266b1e665e1111c61f0a.jpg";